import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type ChatTabType = 'help' | 'chat';

@Injectable({
  providedIn: 'root'
})
export class ChatTabContextService {
  private readonly activeTabSubject = new BehaviorSubject<ChatTabType>('help');

  get activeTab$(): Observable<ChatTabType> {
    return this.activeTabSubject.asObservable();
  }

  get activeTab(): ChatTabType {
    return this.activeTabSubject.getValue();
  }

  setActiveTab(tab: ChatTabType): void {
    this.activeTabSubject.next(tab);
  }
}
